<template>
  <aside class="b-choices non-printable">
    <div class="b-choices-head">
      <span class="b-choices-title">Dina val</span>
      <button type="button" class="b-choices-toggle" @click="open = !open">
        {{ open ? 'Dölj mina val' : 'Visa mina val' }}
      </button>
    </div>

    <div v-show="open" class="b-choices-body">
      <p v-if="!customerItems.length && !forms.length" class="b-choices-empty">
        Inga val gjorda ännu.
      </p>

      <div v-if="customerItems.length" class="b-choices-group">
        <div class="b-choices-group-title">Kunduppgifter</div>
        <dl>
          <div v-for="item in customerItems" :key="item.label" class="b-choices-item">
            <dt>{{ item.label }}</dt>
            <dd>{{ item.value }}</dd>
          </div>
        </dl>
      </div>

      <div v-if="forms.length" class="b-choices-group">
        <div class="b-choices-group-title">Brunnar ({{ forms.length }})</div>

        <div v-for="(well, i) in wellRows" :key="i" class="b-choices-well">
          <button
            type="button"
            class="b-choices-well-toggle"
            :class="{ 'is-open': expanded[i] }"
            :aria-expanded="expanded[i] ? 'true' : 'false'"
            @click="toggle(i)"
          >
            <span class="b-caret"></span>
            <span>{{ well.title }}</span>
          </button>

          <div v-show="expanded[i]" class="b-choices-well-body">
            <dl v-if="well.fields.length">
              <div v-for="item in well.fields" :key="item.label" class="b-choices-item">
                <dt>{{ item.label }}</dt>
                <dd>{{ item.value }}</dd>
              </div>
            </dl>
            <p v-else class="b-choices-empty">Inga uppgifter ifyllda ännu.</p>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { customerFields, wellFields } from '@/formFields.js'

export default {
  name: 'ChoiceSummary',
  props: {
    customer: { type: Object, required: true },
    common: { type: Object, required: true },
    forms: { type: Array, required: true },
  },
  data() {
    return {
      open: true,
      // Tom = alla brunnar hopfällda. Indexbaserat, samma mönster som
      // store.collapsedStates använder för brunnsblocken i steg 2.
      expanded: [],
    }
  },
  computed: {
    // Bara ifyllda fält visas – panelen växer i takt med formuläret.
    // Den smala spalten använder de korta etiketterna där sådana finns.
    customerItems() {
      const source = { customer: this.customer, common: this.common }
      return customerFields
        .map((f) => ({ label: f.short || f.label, value: f.value(source) }))
        .filter(this.isFilled)
    },

    // En post per brunn: rubrik enligt sammanfattningsstegets namngivning
    // ("Brunn 1 — littera") plus de fält som faktiskt är ifyllda.
    // Littera utelämnas ur fältlistan – den står redan i rubriken.
    wellRows() {
      return this.forms.map((form, i) => {
        const inlets = (form.items || []).length - 1
        const fields = wellFields
          .filter((f) => f.key !== 'littera')
          .map((f) => ({
            label: f.short || f.label,
            // Ø-prefixet är panelens egen formatering, inte en del av modellen.
            value: f.key === 'dimension' && form.dimension ? `Ø ${form.dimension}` : f.value(form),
          }))
          .filter(this.isFilled)

        // Antalet inlopp är härlett, inte ett fält – därför inte i wellFields.
        if (inlets > 0) fields.push({ label: 'Inlopp', value: String(inlets) })

        return {
          title: form.littera ? `Brunn ${i + 1} — ${form.littera}` : `Brunn ${i + 1}`,
          fields,
        }
      })
    },
  },
  methods: {
    isFilled(item) {
      return item.value && String(item.value).trim() !== ''
    },
    toggle(i) {
      this.expanded[i] = !this.expanded[i]
    },
  },
}
</script>
